import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item", "button", "text"]
  static values = { limit: { type: Number, default: 7 } }

  connect() {
    if (this.itemTargets.length <= this.limitValue) return

    this.expanded = false
    this.hideExtraItems()
    this.buttonTarget.classList.remove("d-none")
  }

  toggle() {
    this.expanded = !this.expanded

    this.itemTargets.forEach((item, index) => {
      if (index >= this.limitValue) {
        item.style.display = this.expanded ? "inline" : "none"
      }
    })

    this.textTarget.textContent = this.expanded ? "View Less" : "View More"
  }

  hideExtraItems() {
    this.itemTargets.forEach((item, index) => {
      if (index >= this.limitValue) {
        item.style.display = "none"
      }
    })
  }
}
